export const ETF_CODE = '00981A'

export function normalizeDate(value) {
  const text = String(value ?? '').trim()
  if (/^\d{8}$/.test(text)) {
    return `${text.slice(0, 4)}-${text.slice(4, 6)}-${text.slice(6, 8)}`
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
    return text
  }
  throw new Error('資料日期格式可能已變更')
}

export function parseHoldingNumber(value) {
  if (typeof value === 'number') {
    return value
  }

  const normalized = String(value ?? '')
    .replace(/,/g, '')
    .replace(/%/g, '')
    .trim()

  const number = Number(normalized)
  if (!Number.isFinite(number)) {
    throw new Error('資料格式可能已變更')
  }
  return number
}

export function parsePocketFundHoldingResponse(response, options = {}) {
  const rows = response?.Data
  if (!Array.isArray(rows) || rows.length === 0) {
    throw new Error('本次未取得持股明細')
  }

  const holdings = rows.map((row) => {
    if (!Array.isArray(row) || row.length < 6) {
      throw new Error('資料格式可能已變更')
    }

    return {
      code: String(row[1]).trim(),
      name: String(row[2]).trim(),
      weight: parseHoldingNumber(row[3]),
      shares: parseHoldingNumber(row[4]),
      unit: String(row[5]).trim(),
    }
  })

  const date = normalizeDate(rows[0][0])

  return {
    etfCode: ETF_CODE,
    date,
    sourceUrl: options.sourceUrl ?? '',
    fetchedAt: options.fetchedAt ?? new Date().toISOString(),
    holdings,
  }
}
